"use strict";

// A sample component

const Menu = {
  app: null,
  burgerElt: null,
  navElt: null,
  navItemsElt: null,
  labelSubmenu: null,
  init: () => {
    let burger = document.querySelector(".burger-menu");
    if (burger) {
      Menu.burgerElt = burger;
      Menu.navElt = document.querySelector(".c-menu__list");
      Menu.navItemsElt = document.querySelectorAll(".c-menu__list > li");
      Menu.app = document.querySelector(".app");
      Menu.labelSubmenu = document
        .querySelector(".c-menu")
        .getAttribute("data-label-submenu");
      Menu.event();
      if (window.matchMedia("(max-width: 991px)").matches) {
        Menu.addBtnBack();
      }

      if (Menu.navElt) {
        let submenus = Menu.navElt.querySelectorAll(".menu-item-has-children");

        if (submenus.length) {
          submenus.forEach((submenu, index) => {
            let link = submenu.querySelector("a");
            let list = submenu.querySelector("ul");
            list.setAttribute("id", `submenu-${index}`);
            link.setAttribute("role", "button");
            link.setAttribute("aria-expanded", "false");
            link.setAttribute("aria-controls", `submenu-${index}`);
            link.innerHTML += `<span class="sr-only">${Menu.labelSubmenu} ${link.textContent}</span>`;

            list
              .querySelectorAll("a")
              .forEach((childLink) => childLink.setAttribute("tabindex", "-1"));
          });
        }
      }
    }
  },
  event: () => {
    Menu.burgerElt.addEventListener("click", (e) => {
      e.preventDefault();
      if (Menu.app.classList.contains("open--")) {
        //close menu
        Menu.burgerElt.classList.remove("open--");
        Menu.burgerElt.setAttribute("aria-expanded", "false");
        Menu.app.classList.remove("open--");
        document.body.style.overflow = "auto";
        document.documentElement.style.overflow = "auto";
        Menu.navElt.classList.remove("hasHover--");
        if (Menu.navElt.querySelector("li.hover--")) {
          Menu.navElt.querySelector("li.hover--").classList.remove("hover--");
        }
      } else {
        //open menu
        Menu.burgerElt.classList.add("open--");
        Menu.burgerElt.setAttribute("aria-expanded", "true");
        Menu.app.classList.add("open--");
        document.body.style.overflow = "hidden";
        document.documentElement.style.overflow = "hidden";
      }
    });

    const handleNavItems = (e, elt) => {
      if (Menu.navElt.querySelector("li.hover--")) {
        if (
          Menu.navElt
            .querySelector("li.hover--")
            .classList.contains("menu-item-has-children")
        ) {
          Menu.navElt
            .querySelector("li.hover--")
            .querySelector("a")
            .setAttribute("aria-expanded", "false");
        }
        Menu.navElt
          .querySelector("li.hover--")
          .querySelectorAll(".sub-menu a")
          .forEach((childLink) => childLink.setAttribute("tabindex", "-1"));
        Menu.navElt.querySelector("li.hover--").classList.remove("hover--");
      }
      elt.classList.add("hover--");
      if (elt.classList.contains("menu-item-has-children")) {
        e.preventDefault();
        Menu.navElt.classList.add("hasHover--");
        elt.querySelector("a").setAttribute("aria-expanded", "true");
        elt
          .querySelectorAll(".sub-menu a")
          .forEach((childLink) => childLink.setAttribute("tabindex", "0"));
      }
    };

    Menu.navItemsElt.forEach((elt) => {
      elt.querySelector("a").addEventListener("click", (e) => {
        handleNavItems(e, elt);
      });
      if (elt.classList.contains("menu-item-has-children")) {
        elt.querySelector("a").addEventListener("click", (e) => {
          e.preventDefault();
        });
      }
    });

    if (!window.matchMedia("(max-width: 991px)").matches) {
      Menu.navItemsElt.forEach((elt) => {
        elt.querySelector("a").addEventListener("mouseover", (e) => {
          handleNavItems(e, elt);
        });
      });
    }
  },
  addBtnBack: () => {
    const subMenu = Menu.navElt.querySelectorAll(".sub-menu");
    subMenu.forEach((elt) => {
      const newEl = document.createElement("li");
      newEl.innerHTML = `<button class="btn-back"><i aria-hidden="true" class="icon-arrow"></i><span class="simpleLink">${
        elt.closest("li").querySelector("a").innerHTML
      }</span></button>`;
      elt.prepend(newEl);
    });

    Menu.navElt.querySelectorAll(".btn-back").forEach((elt) => {
      elt.addEventListener("click", (e) => {
        e.preventDefault();
        Menu.resetMenuNav();
      });
    });
  },
  resetMenuNav: () => {
    if (Menu.navElt.querySelector("li.hover--")) {
      Menu.navElt.querySelector("li.hover--").classList.remove("hover--");
    }
    Menu.navElt.classList.remove("hasHover--");
  },
};

export default Menu;
